/**
 * setTimeout stores its delay as a signed 32-bit int, so any delay above this
 * overflows and fires on the next tick instead of far in the future. Clamp
 * anything derived from a server timestamp with Math.min before scheduling.
 */
export const MAX_TIMEOUT_DELAY = 2_147_483_647;
